import { FaBoxOpen, FaBalanceScaleLeft } from 'react-icons/fa';
import { BotonesTabla } from './usuariosComponents';

export const customStyles = {
  rows: {
    style: {
      minHeight: '45px', // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
      backgroundColor: '#debfb5',
      fontSize: '16px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
      fontSize: '15px',
    },
  },
};

export function columns(verBalance, verProductos) {
  return [
    {
      name: 'Nombre y Apellido',
      selector: row => row.nombreCompleto,
      sortable: true,
    },
    {
      name: 'Identificador',
      selector: row => row.identificador,
      sortable: true,
    },
    {
      name: 'DNI',
      selector: row => row.dni,
      sortable: true,
      maxWidth: '150px',
    },
    {
      name: 'Telefono',
      selector: row => row.telefono,
      sortable: true,
      maxWidth: '150px',
    },
    {
      name: 'E-Mail',
      selector: row => row.email,
      sortable: true,
    },
    {
      name: 'Preferencia de pago',
      selector: row => row.preferenciaPago,
      sortable: true,
    },
    {
      name: 'Direccion',
      selector: (row) => {
        if (!row.calle) return '';
        let direccion = row.calle;
        if (row.numero)
          direccion = direccion.concat(` ${row.numero} `);
        if (row.dpto)
          direccion = direccion.concat(`dpto:${row.dpto}`);
        return direccion;
      },
      sortable: true,
      title: 'direccion',
      wrap: true,
    },
    {
      name: 'Acciones',
      button: true,
      selector: (row) => (
        <BotonesTabla>
          <FaBalanceScaleLeft
            size='1.2rem'
            onClick={() => {
              verBalance(row);
            }}
            title='Ver Balance'
            cursor='pointer'
          />
          <FaBoxOpen
            size='1.2rem'
            onClick={() => verProductos(row)}
            title='Ver Productos'
            cursor='pointer'
          />
        </BotonesTabla>
      ),
    },
  ];
}
export const opcionesdepagina = {
  rowsPerPageText: 'Filas por pagina',
  rangeSeparatorText: 'de',
  selectAllRowsItem: false,
};
